import type { ProductAttribute } from "./types"

/**
 * Canonical localized labels for every product attribute. Both apps
 * (business + public-web) consume this single source so the labels
 * cannot drift between surfaces. App-specific copy (form input labels,
 * featured-picker CTAs, etc.) stays per-app — only the attribute label
 * vocabulary itself lives here.
 */

type Labels = Record<ProductAttribute, string>

export const PRODUCT_ATTRIBUTE_LABELS_EN: Labels = {
	halal: "Halal",
	vegetarian: "Vegetarian",
	vegan: "Vegan",
	sugar_free: "Sugar-free",
	kosher: "Kosher",
	organic: "Organic",
	demeter: "Demeter",
	fair_trade: "Fair trade",
	zero_km: "Locally sourced",
	regional: "Regional",
	handmade: "Handmade",
	for_sharing: "To share",
	spicy: "Spicy",
	specialty: "Specialty",
	award_winning: "Award-winning",
}

export const PRODUCT_ATTRIBUTE_LABELS_IT: Labels = {
	halal: "Halal",
	vegetarian: "Vegetariano",
	vegan: "Vegano",
	sugar_free: "Senza zuccheri",
	kosher: "Kosher",
	organic: "Biologico",
	demeter: "Demeter",
	fair_trade: "Equo solidale",
	zero_km: "KM zero",
	regional: "Regionale",
	handmade: "Fatto a mano",
	for_sharing: "Da condividere",
	spicy: "Piccante",
	specialty: "Specialità",
	award_winning: "Premiato",
}

export const PRODUCT_ATTRIBUTE_LABELS_FR: Labels = {
	halal: "Halal",
	vegetarian: "Végétarien",
	vegan: "Végétalien",
	sugar_free: "Sans sucre",
	kosher: "Casher",
	organic: "Bio",
	demeter: "Demeter",
	fair_trade: "Commerce équitable",
	zero_km: "Circuit court",
	regional: "Régional",
	handmade: "Fait main",
	for_sharing: "À partager",
	spicy: "Épicé",
	specialty: "Spécialité",
	award_winning: "Primé",
}

export const PRODUCT_ATTRIBUTE_LABELS_DE: Labels = {
	halal: "Halal",
	vegetarian: "Vegetarisch",
	vegan: "Vegan",
	sugar_free: "Zuckerfrei",
	kosher: "Koscher",
	organic: "Bio",
	demeter: "Demeter",
	fair_trade: "Fairer Handel",
	zero_km: "Aus der Region",
	regional: "Regional",
	handmade: "Handgemacht",
	for_sharing: "Zum Teilen",
	spicy: "Scharf",
	specialty: "Spezialität",
	award_winning: "Ausgezeichnet",
}

export const PRODUCT_ATTRIBUTE_LABELS_ES: Labels = {
	halal: "Halal",
	vegetarian: "Vegetariano",
	vegan: "Vegano",
	sugar_free: "Sin azúcar",
	kosher: "Kosher",
	organic: "Ecológico",
	demeter: "Demeter",
	fair_trade: "Comercio justo",
	zero_km: "KM cero",
	regional: "Regional",
	handmade: "Hecho a mano",
	for_sharing: "Para compartir",
	spicy: "Picante",
	specialty: "Especialidad",
	award_winning: "Premiado",
}

export const PRODUCT_ATTRIBUTE_LABELS_PT: Labels = {
	halal: "Halal",
	vegetarian: "Vegetariano",
	vegan: "Vegano",
	sugar_free: "Sem açúcar",
	kosher: "Kosher",
	organic: "Biológico",
	demeter: "Demeter",
	fair_trade: "Comércio justo",
	zero_km: "Produção local",
	regional: "Regional",
	handmade: "Feito à mão",
	for_sharing: "Para partilhar",
	spicy: "Picante",
	specialty: "Especialidade",
	award_winning: "Premiado",
}
